export default {
  home: {
    title: 'Inicio'
  },
  'login-form': {
    title: 'Inicia sesión'
  },
  'email-recover': {
    title: 'Recupera tu contraseña'
  },
  'code-verification': {
    title: 'Código de Verificación'
  },
  'change-password': {
    title: 'Reestablece tu conteraseña'
  },
  'register-form': {
    title: 'Crea una cuenta'
  },
  rims: {
    title: 'Búsqueda por medida'
  },
  tyres: {
    title: 'Listado de llantas'
  },
  'tyre-detail': {
    title: false
  },
  'tyre-family': {
    title: 'Búsqueda por gama'
  },
  brand: {
    title: 'Marca - Búsqueda por automóvil'
  },
  models: {
    title: 'Modelo - Búsqueda por automóvil'
  },
  years: {
    title: 'Año - Búsqueda por automóvil'
  },
  version: {
    title: 'Versión - Búsqueda por automóvil'
  },
  mspn: {
    title: 'Búsqueda por CAI'
  },
  news: {
    title: 'Noticias'
  },
  'news-view': {
    title: false
  },
  application: {
    title: 'Búsqueda por aplicación'
  },
  categories: {
    title: 'Busqueda por categoría'
  },
  'home-selection': {
    title: 'Inicio'
  },
  courses: {
    title: 'Cápsulas'
  },
  'courses-detail': {
    title: 'Cápsulas'
  }
}
